import "./ZocoToggle.css";

/** Public booking opt-in; internal reservations remain available in either state. */
export default function OnlineBookingSwitch({
	checked,
	onChange,
	disabled = false,
}) {
	const enabled = checked === true;
	return (
		<div className="zr-row-toggle">
			<div className="zr-row-toggle__txt">
				<div className="t">Reservas Online</div>
				<div className="h">
					{enabled
						? "Los clientes pueden reservar online."
						: "Las reservas online están desactivadas."}{" "}
					Podés seguir cargando reservas desde tu panel.
				</div>
			</div>
			<button
				type="button"
				role="switch"
				aria-label="Habilitar reservas online"
				aria-checked={enabled}
				disabled={disabled}
				className={`zoco-toggle zoco-toggle--lg${enabled ? " is-on" : ""}`}
				onClick={() => onChange(!enabled)}
			>
				<span className="knob" aria-hidden="true" />
			</button>
		</div>
	);
}
